export const BASE_DURATION_SECONDS =
  22 * 60 * 60 + // 22 hours
  48 * 60 + // 48 minutes
  19 // 19 seconds

export const BASE_DURATION_MS = BASE_DURATION_SECONDS * 1000

export function formatTime(ms) {
  const totalSeconds = Math.floor(ms / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  const pad = (n) => n.toString().padStart(2, '0')

  return {
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
  }
}

export function getTodayString() {
  return new Date().toISOString().slice(0, 10) // "YYYY-MM-DD"
}

export function getRemainingMsFromStart(startTime) {
  const now = Date.now()
  const elapsed = now - startTime // ms since start
  const cyclePosition = elapsed % BASE_DURATION_MS // ms into current cycle
  return BASE_DURATION_MS - cyclePosition // ms left
}
